import { memo, useCallback } from 'react';
import { Linking } from 'react-native';
import { ShouldStartLoadRequest } from 'react-native-webview/lib/WebViewTypes';
import { useNavigation } from '@betty/navigation';
import { logError } from '@betty/toolkit/logging';
import { WebView, WebViewMessageEvent } from '@betty/moonlight';
import { DepositInteracURLProps } from './DepositInteracURL.types';

function DepositInteracURL({ url }: DepositInteracURLProps) {
  const navigation = useNavigation();

  const onMessage = useCallback(
    (e: WebViewMessageEvent) => {
      const msgString = e.nativeEvent.data;

      try {
        const { type } = JSON.parse(msgString);

        if (type === 'CLOSE') {
          navigation.goBack();
        }
      } catch (e) {
        logError('DepositInteracWebviewParseMessage', e);
      }
    },
    [navigation],
  );

  const onShouldStartLoadWithRequest = useCallback(
    (request: ShouldStartLoadRequest) => {
      const { origin } = new URL(url);

      if (
        request.mainDocumentURL &&
        !request.mainDocumentURL?.match(`^${origin}`)
      ) {
        void Linking.openURL(request.url);

        return false;
      }

      return true;
    },
    [url],
  );

  return (
    <WebView
      scrollEnabled
      source={{ uri: url }}
      injectedJavaScript={`
        window.close = function() {
          window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'CLOSE' }));
        };
      `}
      onMessage={onMessage}
      onShouldStartLoadWithRequest={onShouldStartLoadWithRequest}
    />
  );
}

export default memo(DepositInteracURL);
